import Grid from '@mui/material/Grid';
import DialogModal from '../dialog'
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { isClient, isInfollion } from '../../utils/role';
import PdfViewer from '../pdf-viewer/pdf';
import { SxProps, Theme } from '@mui/material';

type Props = {
    isOpen: boolean;
    handleClose(): void;
    image: string | null;
    openEditDialog(): void;
    openDeleteDialog(): void;
    showOnlyImage?: boolean;
    title?: string;
    is_pdf?: boolean;
    grid_sx?: SxProps<Theme>;
}

const ProfilePictureDialog = ({ isOpen, handleClose, image, openEditDialog, openDeleteDialog,showOnlyImage = false,title = "", is_pdf, grid_sx = {}}: Props) => {
    return (
        <DialogModal
            isOpen={isOpen}
            handleClose={handleClose}
            title={title || "Profile photo"}
            contentSx={{
                backgroundColor: "#1B1F23",
                color: "#ffffff"
            }}
            titleSx={{
                backgroundColor: "#1B1F23",
                color: "#ffffff",
                "& p": {
                    fontWeight: "600 !important"
                }
            }}
        >
            <Grid container>
                <Grid item sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5rem",
                    ...grid_sx
                }} xs={12}>
                    {image ? is_pdf ? <>
                    <PdfViewer 
                        pdfUrl={image}
                        sx={{height:"600px"}}
                    />
                    </> : <img src={image} alt='profile' /> : <p>No Image to Show</p>}
                </Grid>
                {!isClient() && !isInfollion() && !showOnlyImage &&
                    <Grid item xs={12} sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        <Button variant="outlined"
                            onClick={openEditDialog}
                            startIcon={<EditIcon />}
                            sx={{
                                borderColor: "white",
                                color: "white",
                                textTransform: "capitalize",
                                "&:hover": {
                                    borderColor: "white"
                                }
                            }}
                        >
                            {image ? "Edit" : "Add"}
                        </Button>
                        {image &&
                            <Button variant="text"
                                onClick={openDeleteDialog}
                                startIcon={<DeleteOutlinedIcon />}
                                sx={{
                                    borderColor: "white",
                                    color: "white",
                                    textTransform: "capitalize",
                                    "&:hover": {
                                        borderColor: "white"
                                    }
                                }}
                            >
                                Delete
                            </Button>
                        }
                    </Grid>
                }
            </Grid>
        </DialogModal>
    )
}

export default ProfilePictureDialog